export const PUT_NOTIFICATION = 'PUT_NOTIFICATION';
export const DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION';
